import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrationContainerImageScannerDataProviderFactory } from '../factory/IntegrationContainerImageScannerDataProviderFactory';
import { IntegrationContainerImageScannerBaseDataProvider } from '../dataProvider/IntegrationContainerImageScannerBaseDataProvider';
import { GetAccessTokenResponse, GetServerUrlResponse, IntegrationContainerImageScannerWebComponentSchema } from '../types';

export class IntegrationContainerImageScannerRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrationContainerImageScannerDataProviderFactory;
  public dataProvider: IntegrationContainerImageScannerBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrationContainerImageScannerDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IntegrationContainerImageScannerWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  public async getAccessToken(companyId: string): Promise<GetAccessTokenResponse> {
    return this.dataProvider.getAccessToken(companyId);
  }

  public async getServerUrl(): Promise<GetServerUrlResponse> {
    return this.dataProvider.getServerUrl();
  }
}
